module.exports = __webpack_public_path__ + "static/img/two.d98d1772.png";